/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { TProfileResponse } from "../../model/types";

export function resolveProfileName(profile: TProfileResponse): string {
  const name: string | undefined = profile.attributes.name;
  return name !== undefined && name.length > 0 ? name : profile.profileId;
}

/**
 * Admin first, then the rest oldest-created to newest, so the list order
 * matches account setup order regardless of the order the server returns.
 */
export function sortProfilesForDisplay(
  profiles: Array<TProfileResponse>
): Array<TProfileResponse> {
  return [...profiles].sort(
    (profileA: TProfileResponse, profileB: TProfileResponse): number => {
      if (profileA.isAdmin === true && profileB.isAdmin !== true) {
        return -1;
      }
      if (profileB.isAdmin === true && profileA.isAdmin !== true) {
        return 1;
      }
      const createdAtA: string =
        profileA.createdAt !== undefined ? profileA.createdAt : "";
      const createdAtB: string =
        profileB.createdAt !== undefined ? profileB.createdAt : "";
      return createdAtA.localeCompare(createdAtB);
    }
  );
}
